import { render } from "./BadgeType.vue?vue&type=template&id=1e5536e0&scoped=true"
import script from "./BadgeType.vue?vue&type=script&lang=js"
export * from "./BadgeType.vue?vue&type=script&lang=js"

import "./BadgeType.vue?vue&type=style&index=0&id=1e5536e0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5536e0"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
